var canvas, canvas2, text, newText, zoom, cWidth = 2400, cHeight = 1800,
    halfWidth = cWidth / 2, halfHeight = cHeight / 2,
    obj, array = [], get_data, sizeCrop,
    scale_factor, newheight, leftOb, imageUrl,
    placeholderimg1, currentSignature,
    placeholderimg4,img,
    leftMarker, rightMarker, vLine;

var loader = jQuery('#customLoader'),
    cropper = "", canvas, boxWidth, boxLeft, boxTop,
    croppedSize, orientations, aspectRatio, reCroper,
    c1img1;

var outLine,sizeBmW = 715, sizeBmH = 450,
    sizeB0W = 709, sizeB0H = 267,
    sizeB1W = 325, sizeB1H = 134;

imageUrl = document.getElementById('imageContainer').getAttribute('data-image-url');



let backImg = document.querySelector("#background_birthday");
let squareImg = document.querySelector("#square_background");

window.bg_img = new fabric.Image(backImg, {
    left:0,
    top:0,
    scaleX:2.345,
    scaleY:2.345,
    selectable:false,
    visible:true
});

window.squareBackground = new fabric.Image(squareImg, {
    left:0,
    top:0,
    scaleX:2.345,
    scaleY:2.345,
    selectable:false,
    visible:false
});

window.canvas2 = new fabric.Canvas("canvas2",{
    width:cWidth,
    height:cHeight,
    allowTouchScrolling:true
});

canvas2.add(window.bg_img);
canvas2.add(window.squareBackground);

window.bg_img.sendToBack();
window.squareBackground.sendToBack();



const certificateLayouts = {

  // Rectangle
  "6 x 8": {
    canvas: {
      width: 2400,
      height: 1800,
      bgScaleX: 2.345,
      bgScaleY: 2.345
    },

    logo: {
      left: 910,
      top: 195,
      width: 709,
      height: 267
    },

    uploadSignature: {
        left:1405,
        top:1550,
        width:325,
        height:134
    },

    manualSignature: {
        left:1245,
        top:1445,
        scaleX:1.10,
        scaleY:1.10
    },

    text2: { left:900, top:1000, maxWidth:1050 }, //entername
    text4: { left:925, top:1240, maxWidth:1680, maxHeight:230, fontSize:55}, //quote text
    text1: { left:375, top:1600, maxWidth:550, fontSize:52 }, //enterdate
    text5: { left:375, top:1680, fontSize:45}, //date text
    text3: { left:1395, top:1585, maxWidth:550, fontSize:110}, //signature text
    text6: { left:1395, top:1680, fontSize:45 } //director text
  },


  // Same layout if needed
  "5 x 7": {
    canvas: {
      width: 2400,
      height: 1800,
      bgScaleX: 2.345,
      bgScaleY: 2.345
    },

    logo: {
      left: 910,
      top: 195,
      width: 709,
      height: 267
    },

    uploadSignature: {
        left:1405,
        top:1550,
        width:325,
        height:134
    },

    manualSignature: {
        left:1245,
        top:1445,
        scaleX:1.10,
        scaleY:1.10
    },

    text2: { left:900, top:1000, maxWidth:1050 }, //entername
    text4: { left:925, top:1240, maxWidth:1680, maxHeight:230, fontSize:55}, //quote text
    text1: { left:375, top:1600, maxWidth:550, fontSize:52 }, //enterdate
    text5: { left:375, top:1680, fontSize:45}, //date text
    text3: { left:1395, top:1585, maxWidth:550, fontSize:110}, //signature text
    text6: { left:1395, top:1680, fontSize:45 } //director text
  },


  // Square layout
  "8 x 8": {

    canvas:{
      width:2400,
      height:2400,
      bgScaleX:2.345,
      bgScaleY:2.345
    },

    logo:{
      left:975,
      top:300,
      width:700,
      height:260
    },

    uploadSignature: {
        left:1530,
        top:2065,
        width:325,
        height:134
    },

    manualSignature: {
        left:1370,
        top:1970,
        scaleX:1.10,
        scaleY:1.10
    },

    text2:{left:975,top:1215,maxWidth:1550}, //entername
    text4:{left:990,top:1600,maxWidth:1830,maxHeight:465,fontSize:75}, //quote text
    text1:{left:395,top:2110,maxWidth:650,fontSize:65}, //enterdate
    text5:{left:370,top:2210,fontSize:55}, //date text
    text3:{left:1530,top:2115,maxWidth:700,fontSize: 65}, //signature text
    text6:{left:1535,top:2210,fontSize:55} //director text
  }

};


function updateCanvasLayout(size){

    const layout = certificateLayouts[size];

    if(!layout) return;

    //-------------------------------------------------
    // Canvas Size
    //-------------------------------------------------

    cWidth = layout.canvas.width;
    cHeight = layout.canvas.height;

    canvas2.setWidth(cWidth);
    canvas2.setHeight(cHeight);

    //-------------------------------------------------
    // Background Image
    //-------------------------------------------------

    if (size === "8 x 8") {

        window.bg_img.set({
            visible: false
        });

        window.squareBackground.set({
            visible: true,
            scaleX: layout.canvas.bgScaleX,
            scaleY: layout.canvas.bgScaleY
        });

        window.squareBackground.sendToBack();

    } else {

        window.squareBackground.set({
            visible: false
        });

        window.bg_img.set({
            visible: true,
            scaleX: layout.canvas.bgScaleX,
            scaleY: layout.canvas.bgScaleY
        });

        window.bg_img.sendToBack();

    }

    //-------------------------------------------------
    // Background
    //-------------------------------------------------

    bg_img.set({
        scaleX: layout.canvas.bgScaleX,
        scaleY: layout.canvas.bgScaleY
    });

    //-------------------------------------------------
    // Logo Placeholder
    //-------------------------------------------------

    placeholderimg0.set({
        left: layout.logo.left,
        top: layout.logo.top,
        width: layout.logo.width,
        height: layout.logo.height
    });

    placeholderimg0.setCoords();

    //-------------------------------------------------
    // Signature Placeholder
    //-------------------------------------------------

    placeholderimg1.set({
        left: layout.uploadSignature.left,
        top: layout.uploadSignature.top,
        width: layout.uploadSignature.width,
        height: layout.uploadSignature.height
    });



    if(currentUploadedImages.first){

        currentUploadedImages.first.set({

            left: layout.uploadSignature.left,
            top: layout.uploadSignature.top,

            scaleX:
                layout.uploadSignature.width /
                currentUploadedImages.first.width,

            scaleY:
                layout.uploadSignature.height /
                currentUploadedImages.first.height

        });

        currentUploadedImages.first.setCoords();
    }

    //-------------------------------------------------
    // Date
    //-------------------------------------------------

    text1Page.set({
        left:layout.text1.left,
        top:layout.text1.top,
        fontSize: layout.text1.fontSize
    });

    fitTextToWidth1(text1Page,layout.text1.maxWidth);

    //-------------------------------------------------
    // Name
    //-------------------------------------------------

    text2Page.set({
        left:layout.text2.left,
        top:layout.text2.top
    });

    fitTextToWidth2(text2Page,layout.text2.maxWidth);

    //-------------------------------------------------
    // Signature Name
    //-------------------------------------------------

    text3Page.set({
        left:layout.text3.left,
        top:layout.text3.top
    });

    fitTextToWidth3(text3Page,layout.text3.maxWidth);

    //-------------------------------------------------
    // Paragraph
    //-------------------------------------------------

    text4Page.set({
        left: layout.text4.left,
        top: layout.text4.top,
        fontSize: layout.text4.fontSize
    });

    maxFontSize = layout.text4.fontSize;

    fitTextToBox(
        text4Page,
        layout.text4.maxWidth,
        layout.text4.maxHeight
    );

    //-------------------------------------------------
    // Labels
    //-------------------------------------------------

    text5Page.set({
        left:layout.text5.left,
        top:layout.text5.top,
        fontSize: layout.text5.fontSize
    });

    text6Page.set({
        left:layout.text6.left,
        top:layout.text6.top,
        fontSize: layout.text6.fontSize
    });


    //-------------------------------------------------
    // Uploaded Images
    //-------------------------------------------------

    if(currentImgInstance){

        moveObjectToPlaceholder(currentImgInstance, placeholderimg0);

        currentImgInstance.set({
            scaleX: placeholderimg0.width / currentImgInstance.width,
            scaleY: placeholderimg0.height / currentImgInstance.height
        });

        currentImgInstance.setCoords();
    }

    //-------------------------------------------------
    // Manual Signature
    //-------------------------------------------------

    if(currentSignature){

        currentSignature.set({
            left: layout.manualSignature.left,
            top: layout.manualSignature.top,
            scaleX: layout.manualSignature.scaleX,
            scaleY: layout.manualSignature.scaleY
        });

        currentSignature.setCoords();

    }

    canvas2.renderAll();

requestAnimationFrame(function(){
    canvasBlock(canvas2);
});

}


document.addEventListener("change", function(e){

    if(
        e.target.matches('input[name="Size"]')
    ){

        updateCanvasLayout(e.target.value);

    }

});


window.addEventListener("load",function(){

    const selected=document.querySelector('input[name="Size"]:checked');

    if(selected){

        updateCanvasLayout(selected.value);

    }

});



let currentImgInstance = null; 


document.addEventListener('DOMContentLoaded', function () {

  setTimeout(function () {

    const defaultImgUrl = document.getElementById('image_preview')?.src;
    const canvas = window['canvas2'];
    const placeholder = window['placeholderimg0'];

    if (defaultImgUrl && canvas && placeholder) {

      fabric.Image.fromURL(defaultImgUrl, function (imgInstance) {

        imgInstance.set({

          // center position
          left: placeholder.left,
          top: placeholder.top,

          originX:'center',
          originY:'center',

          scaleX: placeholder.width / imgInstance.width,
          scaleY: placeholder.height / imgInstance.height,

          selectable:false,
          evented:false,
          hasControls:false,
          hasBorders:false

        });


        canvas.add(imgInstance);

        imgInstance.sendToBack();

        // keep background behind
        window.bg_img.sendToBack();
        window.squareBackground.sendToBack();

        canvas.renderAll();


        currentImgInstance = imgInstance;

        const selected =
        document.querySelector('input[name="Size"]:checked');

        if(selected){
            updateCanvasLayout(selected.value);
        }

      });

    }

  },300);

});




function moveObjectToPlaceholder(obj, placeholder) {
    obj.set({
        left: placeholder.left,
        top: placeholder.top,
        originX: 'center',
        originY: 'center'
    });
}

window['placeholderimg0'] = new fabric.Rect({
  left: 1180,
  top: 195,
  width: sizeB0W,
  height: sizeB0H,
  fill: 'rgba(0,0,0,0)',
  selectable:false,
  evented:false,
  hasControls:false,
  hasBorders:false
});

window['placeholderimg1'] = new fabric.Rect({
  left: 1715,
  top: 1480,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0)',
  rx: 5,
  ry: 5,
  selectable:false,
  evented:false,
  hasControls:false,
  hasBorders:false
});



window['canvas2'].add(window['placeholderimg0'], window['placeholderimg1']);


document.getElementById('image_upload_logo').addEventListener('change', function(e) {
  canvas = window['canvas2'];
  available_height = sizeB0H;
  img = window['placeholderimg0'];
  outline = window['border0'];
  sizeCrop = '2.66';

  if (currentImgInstance) {
    canvas.remove(currentImgInstance);
    currentImgInstance = null;
  }
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height', available_height);
  readURL2(e.target, '#image0');
});


document.getElementById('image_upload_first').addEventListener('change',function(e){
   canvas = window['canvas2'];
   img = window['placeholderimg1'];
   outline = window['border1'];
   available_height = img.height;
   sizeCrop = '2.43';
   reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
   readURL2(e.target);
 });


window['text1Page'] = new fabric.Text('check',{
  left: 655,
  top: 1490,
  fontSize: 52,
  fontFamily: 'Elict Script',
  fill: '#000',
  lockMovementX: true,
  lockMovementY: true,
  originX: 'center',
  originY: 'center',
  selectable:false,
  evented:false,
  hasControls:false,
  hasBorders:false
});


// Add to canvas
window['canvas2'].add(window['text1Page']);

// Clear text on input focus if default
document.getElementById('text_1').addEventListener('focus', function () {
  if (window['text1Page'].text === '05/06/2026') {
    window['text1Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


function fitTextToWidth1(textObj, maxWidth) {
  let fontSize = 50; 
  textObj.set({ fontSize });


  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

document.getElementById('text_1').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text1Page'].set('text', newText);
  fitTextToWidth1(window['text1Page'], 505);
  window['text1Page'].bringToFront();
  window['canvas2'].renderAll();
});




window['text2Page'] = new fabric.Text('PKR 150,000',{
  left: 1200,
  top: 920,
  fontSize: 150,
  fontFamily: 'Trajan Pro',
  fill: '#976e2c',
  lockMovementX: true,
  lockMovementY: true,
  originX: 'center',
  originY: 'center',
  selectable:false,
  evented:false,
  hasControls:false,
  hasBorders:false
});

var fontName = window['text2Page'].fontFamily;
jQuery('.choose_font2').val("'" + fontName + "'").trigger('change');

// Add to canvas
window['canvas2'].add(window['text2Page']);

// Clear text on input focus if default
document.getElementById('text_2').addEventListener('focus', function () {
  if (window['text2Page'].text === 'Zahid Rehman') {
    window['text2Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


function fitTextToWidth2(textObj, maxWidth) {
  let fontSize = 150; 
  textObj.set({ fontSize });


  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

document.getElementById('text_2').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text2Page'].set('text', newText);
  fitTextToWidth2(window['text2Page'], 1050);
  window['text2Page'].bringToFront();
  window['canvas2'].renderAll();
});



window['text3Page'] = new fabric.Text('Faisal Ali',{
  left: 1715,
  top: 1480,
  fontSize: 110,
  fontFamily: 'Bloom Winter',
  fill: '#000',
  lockMovementX: true,
  lockMovementY: true,
  originX: 'center',
  originY: 'center',
  selectable:false,
  evented:false,
  hasControls:false,
  hasBorders:false
});


var fontName = window['text3Page'].fontFamily;
jQuery('.choose_font3').val("'" + fontName + "'").trigger('change');

// Add to canvas
window['canvas2'].add(window['text3Page']);

// Clear text on input focus if default
document.getElementById('text_3').addEventListener('focus', function () {
  if (window['text3Page'].text === 'Faisal Ali') {
    window['text3Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


function fitTextToWidth3(textObj, maxWidth) {
  let fontSize = 110; 
  textObj.set({ fontSize });


  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

document.getElementById('text_3').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text3Page'].set('text', newText);
  fitTextToWidth3(window['text3Page'], 480);
  window['text3Page'].bringToFront();
  window['canvas2'].renderAll();
});





// var maxWidth = 1680;
// var maxHeight = 230;

var para = "This certificate is proudly presented to Shakeel Ahmad in recognition of the successful \n approval and award of funding for outstanding dedication, innovation, and commitment.\nYour achievement reflects excellence, perseverance, and the confidence placed in your vision.\nWe congratulate you on receiving this funded award and wish you continued success\nin all your future endeavors." ;

window['text4Page'] = new fabric.Text(para,{
  left: 1200,
  top: 1180,
  width: 550,
  fontSize: 55,
  lineHeight: 1,
  fontFamily: 'Times New Roman',
  textAlign: 'center',
  isWrapping: true,
  originX: 'center',
  originY: 'center',
  fill: '#000',
  selectable:false,
  evented:false,
  hasControls:false,
  hasBorders:false
});

var fontName2 = window['text4Page'].fontFamily;
jQuery('.choose_font4').val("'" + fontName2 + "'").trigger('change');

window['canvas2'].add(window['text4Page']);


var minFontSize = 10;
var maxFontSize = 55;

// Clear text on input focus if default
document.getElementById('text_4').addEventListener('focus', function () {
  if (window['text4Page'].text === 'This certificate is proudly presented to Shakeel Ahmad in recognition of the successful \n approval and award of funding for outstanding dedication, innovation, and commitment.\nYour achievement reflects excellence, perseverance, and the confidence placed in your vision.\nWe congratulate you on receiving this funded award and wish you continued success\nin all your future endeavors.') {
    window['text4Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


// Helper: Adjust font size to fit both width and height
function autoFitText2(textbox, maxW, maxH) {
  let fontSize = maxFontSize;

  textbox.set({ fontSize });

  while (
    (textbox.width > maxW || textbox.calcTextHeight() > maxH) &&
    fontSize > minFontSize
  ) {
    fontSize -= 1;
    textbox.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

// On input update
document.getElementById('text_4').addEventListener('input', function (e) {

    const selected = document.querySelector('input[name="Size"]:checked');
    const layout = certificateLayouts[selected.value];

    window['text4Page'].set({
        text: e.target.value
    });

    fitTextToBox(
        window['text4Page'],
        layout.text4.maxWidth,
        layout.text4.maxHeight
    );

});


function fitTextToBox(textObj, maxWidth, maxHeight) {

    let fontSize = maxFontSize;

    // Reset to the layout's default size first
    textObj.set({
        width: maxWidth,
        fontSize: fontSize
    });

    while (
        (textObj.width > maxWidth || textObj.height > maxHeight) &&
        fontSize > minFontSize
    ) {
        fontSize--;
        textObj.set({
            fontSize: fontSize
        });
    }

    textObj.setCoords();
    canvas2.renderAll();
}


window['text5Page'] = new fabric.Text('Date',{
  left: 655,
  top: 1580,
  fontSize: 45,
  fontFamily: 'Times New Roman',
  fill: '#000',
  lockMovementX: true,
  lockMovementY: true,
  originX: 'center',
  originY: 'center',
  selectable:false,
  evented:false,
  hasControls:false,
  hasBorders:false
});


window['canvas2'].add(window['text5Page']);


window['text6Page'] = new fabric.Text('Authorized Signature',{
  left: 1715,
  top: 1580,
  fontSize: 45,
  fontFamily: 'Times New Roman',
  fill: '#000',
  lockMovementX: true,
  lockMovementY: true,
  originX: 'center',
  originY: 'center',
  selectable:false,
  evented:false,
  hasControls:false,
  hasBorders:false
});


window['canvas2'].add(window['text6Page']);



function canvasMakeImg(canvas,zoom){
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function canvasBlock(canvas){
  if (!canvas) return;

  var mediaOuter = document.querySelector('.product__media-outer');

  if (!mediaOuter) return;

  var zoom = mediaOuter.getBoundingClientRect().width;

  if (!zoom || zoom <= 0) return;

  var newZoomLevel = zoom / cWidth;

  setZoomMask(canvas,newZoomLevel);
}

function setZoomMask(canvas,newZoomLevel){

  if (!canvas || !newZoomLevel) return;

  canvas.setZoom(newZoomLevel);

  canvas.setDimensions({
    width: cWidth * newZoomLevel,
    height: cHeight * newZoomLevel
  });

  if (canvas.upperCanvasEl) {
    canvas.upperCanvasEl.style.touchAction = 'pan-y';
  }

  if (canvas.lowerCanvasEl) {
    canvas.lowerCanvasEl.style.touchAction = 'pan-y';
  }

  canvas.renderAll();
}

function addModify(canvas){
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;

  canvas.renderOnAddRemove = false;
  canvas.on('selection:cleared', function(e){
    object = e.target;
  });

  canvas.on('object:removed',function(e){
    object = e.target;
  });

  canvas.on('object:added', function(e){
    object = e.target;
    addControls(object);
    canvas.renderAll();
  });
  
  canvas.on('object:modified', function(e){
    object = e.target;
    canvas.renderAll();
  });
  
  canvas.on('selection:created', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('selection:updated', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('object:scaling', function(e){
    canvas.renderAll();
  });

  jQuery(window).on('resize',function(){

  requestAnimationFrame(function(){
    canvasBlock(canvas);
  });

});
}

function addControls(object){
  var iconTL = document.createElement("img"),
      iconBR = document.createElement("img");
  
  iconTL.src = trashIcon;
  iconBR.src = resizeIcon;
  
  object.set({
    selectable:false,
    originX:"center",
    originY:"center",
    transparentCorners: false,
    borderColor: '#ddd',
    borderDashArray: [6,2],
    cornerStyle: 'circle',
    cornerColor: '#fff',
    objectCaching: false,
    _controlsVisibility: {
      tr: false,
      tl: true,
      bl: false,
      br: true,
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: false
    }
  });
  
  iconTL.onload = function() {
    fabric.Object.prototype.controls.tl = new fabric.Control({
      x: -0.5,
      y: -0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "pointer",
      mouseUpHandler: deleteHandler,
      render: renderIcon(iconTL),
      withConnection: true,
      cornerSize: 18,
    });
  };
  iconBR.onload = function() {
    fabric.Object.prototype.controls.br = new fabric.Control({
      x: 0.5,
      y: 0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "se-resize",
      mouseUpHandler:fabric.controlsUtils.scalingEqually,
      render: renderIcon(iconBR),
      withConnection: true,
      cornerSize: 18,
    });
  }
}

function renderIcon(icon) {
  return function (ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

function deleteHandler() {
  var activeOb = window['canvas2'].getActiveObject();
  if (activeOb) {
    window['canvas2'].remove(activeOb);
    window['canvas2'].renderAll();
  }
}


initCropper();

function readURL2(input){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  if(cropper == ""){
  }else {
    cropper.destroy();
  }
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function (e) {
      jQuery('#blah').attr('src', e.target.result);
      reCroper.attr('data-img',e.target.result);
    };
    reader.readAsDataURL(input.files[0]);
    setTimeout(initCropper, 2500);
  }
}

function addImage(e,placeholderimg,canvas){
  var file = e.target.files[0];
  var reader = new FileReader();
  reader.onload = function(event){
    var imgObj = new Image();
    imgObj.src = event.target.result;
    imgObj.onload = function(){
      var img = new fabric.Image(imgObj);
      img.set({
        left: placeholderimg.left,
        top: placeholderimg.top,
        selectable:true,
        scaleX: placeholderimg.width / img.width,
        scaleY: placeholderimg.height / img.height,
        clipPath: new fabric.Rect({
          width: img.width,
          height: img.height,
          rx: 20, // Apply border radius from placeholder
          ry: 20
        })
      });
    };
  };
  reader.readAsDataURL(file);
}

let currentUploadedImages = {
  logo: null,
  first: null,
  second: null
};
window['placeholderimg0'].objKey = "logo";
window['placeholderimg1'].objKey = "first";

function addCroppedImg(imgurl){
  canvas.remove(img).renderAll();
  // Remove old uploaded image for this placeholder if exists
  if(currentUploadedImages[img.objKey]) {
    canvas.remove(currentUploadedImages[img.objKey]);
  }

  fabric.Image.fromURL(imgurl, function(newImg){
    const scale = newImg.width / img.width;
    newImg.set({
        left: img.left,
        top: img.top,
        originX: 'center',
        originY: 'center'
    });
    newImg.scaleToHeight(available_height);

    // Clip with rounded corners
    const clipPath = new fabric.Rect({
      width: newImg.width,
      height: newImg.height,
      rx: img.rx * scale,
      ry: img.ry * scale,
      left: 0,
      top: 0,
      originX: 'center',
      originY: 'center',
      fill: 'transparent'
    });
    newImg.clipPath = clipPath;

    // Add new image
    canvas.add(newImg);
    if(img.objKey === "logo"){
        currentImgInstance = newImg;
    }
    canvas.bringToFront(outline);

    // Save reference (important!)
    currentUploadedImages[img.objKey] = newImg;

    canvas.renderAll();
  });
}

function initCropper(){
  var image = document.getElementById('blah');
  cropper = new Cropper(image, {
    viewMode: 1,
    dragMode: 'move',
    aspectRatio: sizeCrop,
    restore: false,
    guides: false,
    center: true,
    highlight: true,
    cropBoxMovable: true,
    cropBoxResizable: true,
    toggleDragModeOnDblclick: false,
    data:{}
  });
  jQuery('.popupImg').show();
  jQuery('#tadaWidget').addClass('hidden');
  loader.addClass('hidden');
}

document.getElementById('crop_button').addEventListener('click', function(){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  var imgurl =  cropper.getCroppedCanvas().toDataURL();
  addCroppedImg(imgurl);
  setTimeout(function(){
    reCroper.parent().removeClass('hidden');
    jQuery('.popupImg').hide();
    loader.addClass('hidden');
    jQuery('#tadaWidget').removeClass('hidden');
  },500);
});

document.getElementById('zoom_out').addEventListener('click', function(){
  cropper.zoom(-0.1);
});

document.getElementById('zoom_in').addEventListener('click', function(){
  cropper.zoom(0.1);
});

document.getElementById('reset_button').addEventListener('click', function(){
  cropper.reset();
});

document.getElementById('cancelCropper').addEventListener('click', function(){
  jQuery('.popupImg').hide();
  jQuery('#tadaWidget').removeClass('hidden');
});

jQuery(document).on('click','.btnReCrop', function(){
  loader.removeClass('hidden');
  imgurl = jQuery(this).attr('data-img');
  sizeCrop = jQuery(this).attr('data-ratio');
  img = window[jQuery(this).attr('data-obj')];
  canvas = window[jQuery(this).attr('data-canvas')];
  available_height = jQuery(this).attr('data-height');
  console.log(canvas);
  jQuery('#tadaWidget').addClass('hidden');
  setTimeout(function(){
    cropper.destroy();
    jQuery('#blah').attr('src',imgurl);
    initCropper();
    jQuery('.popupImg').show();
    loader.addClass('hidden');
  },150);
});




// keep signature reference globally
var currentSignature = null;


$(document).ready(function() {
  // Signature pad canvas
  var managersignatureCanvas = new fabric.Canvas('managersignatureCanvas', {
    isDrawingMode: true
  });
  managersignatureCanvas.freeDrawingBrush.color = "#000";
  managersignatureCanvas.freeDrawingBrush.width = 2;

  // On submit
  $("#submitDrawing").on("click", function(e) {
    e.preventDefault();

    if (managersignatureCanvas.isEmpty()) {
      alert("Please draw your signature before submitting.");
      return;
    }

    var signatureData = managersignatureCanvas.toDataURL("image/png");

    fabric.Image.fromURL(signatureData, function(managsign) {

    // Convert black signature to white
    managsign.filters = [
        new fabric.Image.filters.BlendColor({
            color: '#000',
            mode: 'tint',
            alpha: 1
        })
    ];

    managsign.applyFilters();
      if (currentSignature) {
        window['canvas2'].remove(currentSignature);
      }

      managsign.set({
          left:1555,
          top:1340,
          scaleX:1.10,
          scaleY:1.10
      });

      window['canvas2'].add(managsign).setActiveObject(managsign);
      currentSignature = managsign; // ✅ global reference
      window['canvas2'].renderAll();

      // Once user deselects, make it unselectable
      window['canvas2'].on('selection:cleared', function() {
        if (currentSignature) {
          currentSignature.selectable = true;
          currentSignature.hasControls = true;
          currentSignature.hasBorders = true;
          window['canvas2'].renderAll();
        }
      });
      
    });

    managersignatureCanvas.clear();
  });
});




$(document).ready(function () {
  // Hide both by default, then show upload section
  $(".manager_signature_image").hide();
  $(".manually_manager_signature").hide();

  $(".enter_signature").show();
  $(".signature_font").show();

  $("#manager_signature").on("change", function () {

    var value = $(this).val();

    // Hide everything first
    $(".manager_signature_image").hide();
    $(".manually_manager_signature").hide();
    $(".enter_signature").hide();
    $(".signature_font").hide();

    // Hide all canvas objects
    if (window['text3Page'])
        window['text3Page'].set({ visible: false });

    if (typeof currentSignature !== "undefined" && currentSignature)
        currentSignature.set({ visible: false });

    if (window['placeholderimg0'])
        window['placeholderimg0'].set({ visible: false });

    if (window['placeholderimg1'])
        window['placeholderimg1'].set({ visible: false });

    if (typeof currentUploadedImages.first !== "undefined" && currentUploadedImages.first)
        currentUploadedImages.first.set({ visible: false });


    // ==========================
    // TEXT
    // ==========================
    if (value === "text") {

        $(".enter_signature").show();
        $(".signature_font").show();

        if (window['text3Page']) {
            window['text3Page'].set({
                visible: true
            });
            window['text3Page'].bringToFront();
        }

    }

    // ==========================
    // UPLOAD IMAGE
    // ==========================
    else if (value === "upload") {

        $(".manager_signature_image").show();

        if (window['placeholderimg0'])
            window['placeholderimg0'].set({ visible: true });

        if (window['placeholderimg1'])
            window['placeholderimg1'].set({ visible: true });

        if (typeof currentUploadedImages.first !== "undefined" && currentUploadedImages.first)
            currentUploadedImages.first.set({ visible: true });

    }

    // ==========================
    // DRAW SIGNATURE
    // ==========================
    else if (value === "manual") {

        $(".manually_manager_signature").show();

        if (window['placeholderimg0'])
            window['placeholderimg0'].set({ visible: true });

        if (window['placeholderimg1'])
            window['placeholderimg1'].set({ visible: false });

        if (typeof currentSignature !== "undefined" && currentSignature) {
            currentSignature.set({
                visible: true
            });
            currentSignature.bringToFront();
        }

    }

    window['canvas2'].renderAll();

    });
});


jQuery('.customColors').each(function(){
  colorBox = jQuery(this).attr('id');
  loadColorPicker(colorBox);
});

jQuery(document).on('change', '.fontFamily', function () {

    var fontID = jQuery(this).attr('data-canvas'),
        textOb = jQuery(this).attr('data-obj');

    canvas = window[fontID];
    activeOb = window[textOb];

    activeOb.set({
        fontFamily: this.value
    });

    // Get currently selected certificate size
    const selected = document.querySelector('input[name="Size"]:checked');
    const layout = certificateLayouts[selected.value];

    canvas.renderAll();

    fitTextToWidth1(window['text1Page'], layout.text1.maxWidth);
    fitTextToWidth2(window['text2Page'], layout.text2.maxWidth);
    fitTextToWidth3(window['text3Page'], layout.text3.maxWidth);

    // Important
    maxFontSize = layout.text4.fontSize;

    fitTextToBox(
        window['text4Page'],
        layout.text4.maxWidth,
        layout.text4.maxHeight
    );
});


function updateFont(activeOb){
  if(activeOb){
    sCAle = activeOb.scaleX;
    activeOb.set('fontSize',fontSize);
    activeOb.set('fontFamily',fontFamily);
    activeOb.set('fill',activeCOLOR);
    activeOb.scaleX = .5;
    activeOb.setCoords();
    canvas.renderAll();
    activeOb.scaleX = sCAle;
    activeOb.setCoords();
    canvas.renderAll();
  }
}


jQuery(document).on('click','.dropper-eyedrop',function(){
  const eyeDropper = new EyeDropper();
  eyeDropper.open().then(result => {
    jQuery(this).parent().parent().parent().colorpicker('setValue', result.sRGBHex);
  }).catch(e => {
    console.error(e);
  });
});




jQuery(window).on('load',function(){

  requestAnimationFrame(function(){

    requestAnimationFrame(function(){

      canvasBlock(window['canvas2']);

      window['text1Page'].set('text','05/06/2026');

      window['canvas2'].renderAll();

    });

  });

});


function getCookie(name){
  let nameEQ = name + "=";
  let cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++){
    let cookie = cookies[i].trim();
    if(cookie.indexOf(nameEQ) === 0){
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}

window.addEventListener("load", function(){
  if(getCookie("firstVisit")){
    console.log("✅ Cookie exists:", getCookie("firstVisit"));
  } else{
    console.log("❌ Cookie does not exist!");
    document.cookie = "firstVisit=textresizing; expires=" + new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString() + "; path=/;";
    location.reload();
  }
});



async function handleUpload(fileInputs,timeID){
  const temp_images = [];
  
  for (let input of fileInputs){
    const file = input.files[0]; // Only first file per input
    const croppedURL = jQuery(input).attr('data-cropped');
    if(croppedURL != ''){
      temp_images.push(croppedURL);
    }
    if(file){
      const base64 = await toBase64(file); // ✅ now safely inside async
      temp_images.push(base64);
    }
  }
  if(temp_images.length === 0){
    alert("Please select at least one image.");
    return;
  }
  const payload = {
    timeId: timeID,
    temp_images: temp_images
  };
  console.log(payload);
  try {
    const response = await fetch('//technology-architects.com/tasweer-modules/upload_client_img.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    
    const result = await response.json();
    console.log("Upload result:", result);
    var int = 1, wall = 1, upCrop;
    result.uploaded_images.forEach(img => {
      if(jQuery('#image'+int).length < 1){
        if (int % 2 === 0) {
          upCrop = 'User Uploaded ';
        }else{
          upCrop = 'Cropped ';
        }
        jQuery('#preview').append('<input type="hidden" id="image'+int+'" name="properties['+ upCrop + wall+']">');
        if(upCrop == 'User Uploaded '){
          wall += 1;
        }
      }
      if (img.status === "success") {
        jQuery('#image'+int).val(img.image_url);
        int += 1;
      } else {
        console.warn("Upload failed:", img.error);
      }
    });
    jQuery('.product-form__buttons .product-form__submit').trigger('click');
    loader.addClass('hidden');
  } catch (error) {
    console.error("Upload error:", error);
    alert("Upload failed.");
  }
}

// ✅ Convert a file to base64 string
function toBase64(file){
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}


/* fetch Call */
var size,thumbnail;
var loadedObject,enterHeading,chooseFont2,enterDetails,chooseFont4,enterYear,mngSignature,enterSignature,chooseFont3,additionalInfo,wMark,svgMrk;
let pdfData = {};
jQuery(document).on('click','#download',function(){
  loader.removeClass('hidden');
  setTimeout(function(){
    // resizeObjects(window['canvas2']);
    const id = ['canvas2'];
    const canvas = window['canvas2'];
    size = 350;
    loadMark(id,canvas,size);
    size = 4000;
    removeMark(canvas,size);
    // hideExtras(canvas);
    window['canvas2'] = canvas.toDataURL('image/png');
    enterHeading = jQuery('.enter_heading input').val();
    chooseFont2 = jQuery('.choose_font2 option:selected').val();
    enterDetails = jQuery('.enter_details textarea').val();
    chooseFont4 = jQuery('.choose_font4 option:selected').val();
    enterYear = jQuery('.enter_year input').val();
    mngSignature = jQuery('#manager_signature option:selected').val();
    enterSignature = jQuery('.enter_signature input').val();
    chooseFont3 = jQuery('.choose_font3 option:selected').val();
    additionalInfo = jQuery('.tShirtImg textarea').val();
    // showExtras(canvas);
    canvasBlock(canvas);
    console.log(window['canvas2']);
    fetch('//technology-architects.com/tasweer-modules/save_order.php',{
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body:  JSON.stringify({
        temp_image: window['canvas2t'],
        original_image: window['canvas2']
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      var previewId = data[0],
          extraImg1 = data[1];
      jQuery('#previewImg').val(previewId);
      jQuery('#preExtraImg').val(extraImg1);
      jQuery('#enterHeading').val(enterHeading);
      jQuery('#chooseFont2').val(chooseFont2);
      jQuery('#enterDetails').val(enterDetails);
      jQuery('#chooseFont4').val(chooseFont4);
      jQuery('#enterYear').val(enterYear);
      jQuery('#mngSignature').val(mngSignature);
      jQuery('#enterSignature').val(enterSignature);
      jQuery('#chooseFont3').val(chooseFont3);
      jQuery('#addInfo').val(additionalInfo);
      //console.log('Server response:', data);
      const fileInputs = document.querySelectorAll('.upload_image input[type="file"]');
      handleUpload(fileInputs,previewId);
    })
    .catch(error => console.error('Error uploading images:', error));
  },100);
});


// function resizeObjects(canvas) {
//   let objectsToGroup = [];

//   // ✅ Add text fields if exist
//   for (let i = 1; i <= 6; i++) {
//     if (window[`text${i}Page`]) {
//       window[`text${i}Page`].setCoords();
//       objectsToGroup.push(window[`text${i}Page`]);
//     }
//   }

//   // ✅ Add signatures if exist
//   if (typeof currentSignature !== 'undefined' && currentSignature) {
//     currentSignature.setCoords();
//     objectsToGroup.push(currentSignature);
//   }

//   // ✅ Add uploaded images from currentUploadedImages
//   if (typeof currentUploadedImages !== 'undefined') {
//     Object.keys(currentUploadedImages).forEach(key => {
//       if (currentUploadedImages[key]) {
//         currentUploadedImages[key].setCoords();
//         objectsToGroup.push(currentUploadedImages[key]);
//       }
//     });
//   }

//   // ✅ Add placeholder / static images
// //   if (typeof simpleImage !== 'undefined' && simpleImage) {
// //     simpleImage.setCoords();
// //     objectsToGroup.push(simpleImage);
// //   }
//   if (typeof currentImgInstance !== 'undefined' && currentImgInstance) {
//     currentImgInstance.setCoords();
//     objectsToGroup.push(currentImgInstance);
//   }
//   if (typeof img !== 'undefined' && img) {
//     img.setCoords();
//     objectsToGroup.push(img);
//   }
//   if (typeof placeholderimg1 !== 'undefined' && placeholderimg1) {
//     placeholderimg1.setCoords();
//     objectsToGroup.push(placeholderimg1);
//   }

  
//   if (objectsToGroup.length === 0) return;


//   var designResiz = new fabric.Group(objectsToGroup, {
//     left: halfWidth,
//     top: halfHeight,
//     originX: 'center',
//     originY: 'center'
//   });


//   designResiz.scaleToWidth(1300);
//   designResiz.setCoords();

//   canvas.renderAll();
// }



function loadMark(id,canvas,size){
  wMark = document.getElementById('wm_collage');
  svgMrk = wMark.innerHTML;
  fabric.loadSVGFromString(svgMrk, function(objects,options){
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(cWidth);
    loadedObject.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false
    });
    canvas.add(loadedObject);
    loadedObject.bringToFront();
    loadedObject.setCoords();
    canvas.renderAll();
  });
  canvasMakeImg(canvas,size);
  window[id+'t'] = canvas.toDataURL('image/png');
  console.log(window[id+'t']);
}

function removeMark(canvas,size){
  canvas.remove(loadedObject).renderAll();
  canvasMakeImg(canvas,size);
}